import React from "react";
import { Tooltip } from "../Tooltip";
import InfoIcon from "../../assets/InfoIcon";
import { CloudfrontRow } from "./types";
import StatusPill from "./StatusPill";
import styles from "./systemHealth.module.css";

type CloudfrontTableProps = {
  rows: CloudfrontRow[];
};

const CloudfrontTable: React.FC<CloudfrontTableProps> = ({ rows }) => {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.dataTable}>
        <thead>
          <tr>
            <th>Distribution</th>
            <th>Domain</th>
            <th>Alternate Domain</th>
            <th>Deploy Status</th>
            <th>Healthy</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={row.distribution_id}
              className={!row.healthy ? styles.rowUnhealthy : ""}
            >
              <td className={styles.tableNameCell}>
                <div>{row.ui_display_name || row.domain_name}</div>
                <div className={styles.tableSubText}>
                  {row.distribution_id}
                </div>
              </td>
              <td>{row.domain_name}</td>
              <td>{row.alternate_domain_names || "-"}</td>
              <td>
                <StatusPill status={row.status} />
              </td>
              <td>
                <div className={styles.healthyCell}>
                  <StatusPill
                    status={row.healthy}
                    upLabel="Healthy"
                    downLabel="Unhealthy"
                  />
                  {row.error && (
                    <Tooltip text={row.error} maxWidth={320} placement="top">
                      <InfoIcon className={styles.errorInfoIcon} />
                    </Tooltip>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CloudfrontTable;
